import { Alert, Button, Snackbar } from '@mui/material';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { register } from 'serviceWorkerRegistration';

export function RegisterAppUpdate() {
  const location = useLocation();
  const [showReload, setShowReload] = useState(false);
  const [waitingWorker, setWaitingWorker] = useState<ServiceWorker | null>(null);

  const onUpdate = (registration: ServiceWorkerRegistration) => {
    setWaitingWorker(registration.waiting);
  };

  const onInit = (registration: ServiceWorkerRegistration) => {
    setWaitingWorker(registration.waiting);
  };

  const applyUpdate = () => {
    waitingWorker?.addEventListener('statechange', () => {
      if (waitingWorker.state === 'activated') {
        setShowReload(false);
        window.location.reload();
      }
    });
    waitingWorker?.postMessage({ type: 'SKIP_WAITING' });
  };

  useEffect(() => {
    navigator.serviceWorker
      .getRegistrations()
      .then(registrations => registrations.forEach(registration => registration.update()));
  }, [location]);

  useEffect(() => {
    setShowReload(Boolean(waitingWorker));
  }, [waitingWorker]);

  useEffect(() => {
    register({ onUpdate, onInit });
  }, []);
  return (
    <Snackbar open={showReload} onClick={applyUpdate} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
      <Alert
        action={
          <Button onClick={applyUpdate} color='secondary' variant='contained'>
            update
          </Button>
        }
        severity='info'
      >
        A new version is available!
      </Alert>
    </Snackbar>
  );
}
